// app/(main)/compte/favoris/page.tsx
"use client";


import { Heart, Loader2 } from "lucide-react";
import { useFavorites } from "../../../hooks/favorites/useFavorites";
import { PageContainer } from "../../../components/ui/PageContainer";
import { ProductsList } from "../../../components/shared/products/ProductsList";



export default function FavoritesPage() {
  const { favorites, isLoading } = useFavorites();



  if (isLoading) {
    return (
      <div className="flex justify-center py-12">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
      </div>
    );
  }

  if (favorites.length === 0) {
    return (
      <div className="text-center py-12">
        <Heart className="w-12 h-12 text-gray-300 mx-auto mb-3" />
        <p className="text-gray-500">Aucun favori pour le moment</p>
        <p className="text-sm text-gray-400 mt-1">
          Ajoutez des produits à vos favoris pour les retrouver facilement
        </p>
      </div>
    );
  }

  return (
    <PageContainer withContainer>
      <ProductsList
        products={[...favorites , ...favorites, ...favorites]}
        layout="grid"
        showActionBtn={true}
        showDescription={false}
        showRating={true}
        showReviewsCount={true}
        showShopName={true}
        showShopAddress={false}
      />
    </PageContainer>
  );
}